"use client";

import { TabButton } from "@/components/institution/TabButton";
import { translations } from "@/messages";
import { AlertTriangle, BookOpenCheck, Send, Wallet } from "lucide-react";
import { useLocale } from "use-intl";
import Link from "next/link";
import { usePathname } from "next/navigation";
export type TabType = "send-request" | "new-payment" | "issues-and-reports" | "transparency";
type TabsProps = {
  institutionSlug: string;
  showIssuesForms: boolean;
};
export const Tabs = (props: TabsProps) => {
  const locale = useLocale() as keyof typeof translations;
  const pathname = usePathname();
  const [_bp, rest] = pathname.split(`/uat/${props.institutionSlug}`);
  const currentTab = rest!.split("/").filter(Boolean)[0];
  return <div className="flex flex-wrap justify-between gap-2 mobile:gap-4 tablet:justify-normal" data-sentry-component="Tabs" data-sentry-source-file="Tabs.tsx">
      <Link href={`/uat/${props.institutionSlug}/send-request`} className="min-w-[8rem] flex-1 tablet:flex-none" data-sentry-element="Link" data-sentry-source-file="Tabs.tsx">
        <TabButton value="send-request" currentTab={currentTab} icon={<Send size={20} />} label={translations[locale]["institution"]["sendRequest"]} data-sentry-element="TabButton" data-sentry-source-file="Tabs.tsx" />
      </Link>
      {locale === "ro" && <Link href={`/uat/${props.institutionSlug}/new-payment`} className="min-w-[8rem] flex-1 tablet:flex-none">
          <TabButton value="new-payment" currentTab={currentTab} icon={<Wallet size={20} />} label={translations[locale]["institution"]["newPayment"]} />
        </Link>}
      {props.showIssuesForms && <Link href={`/uat/${props.institutionSlug}/issues-and-reports`} className="min-w-[8rem] flex-1 tablet:flex-none">
          <TabButton value="issues-and-reports" currentTab={currentTab} icon={<AlertTriangle size={20} />} label={translations[locale]["institution"]["issuesAndReports"]} />
        </Link>}
      <div className="hidden h-auto px-2 py-4 desktop:block">
        <div className="h-full w-[1px] rounded-3xl bg-glow/10"></div>
      </div>
      <Link href={`/uat/${props.institutionSlug}/transparency`} className="min-w-[8rem] flex-1 tablet:flex-none" data-sentry-element="Link" data-sentry-source-file="Tabs.tsx">
        <TabButton value="transparency" currentTab={currentTab} icon={<BookOpenCheck size={20} />} label={translations[locale]["institution"]["transparency"]} data-sentry-element="TabButton" data-sentry-source-file="Tabs.tsx" />
      </Link>
    </div>;
};